import { render, staticRenderFns } from "./DirectoryLinks.vue?vue&type=template&id=a6c446fc&"
import script from "./DirectoryLinks.vue?vue&type=script&lang=js&"
export * from "./DirectoryLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports